export const CASES = {
    UPDATE_PRODUCTS: 'UPDATE_PRODUCTS',
    UPDATE_PRODUCTS_FILTER_FORM: 'UPDATE_PRODUCTS_FILTER_FORM',
    CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',
};
